<template>
  <span v-if="$i18n.locale=='pt-BR'">{{ dayWeek }}, {{ date.getDate() }} de {{ month }} de {{ date.getFullYear() }}</span>
  <span v-else-if="$i18n.locale=='en'">{{ dayWeek }}, {{ month }} {{ date.getDate() }}, {{ date.getFullYear() }}</span>
</template>
<script>

export default{
  props: {
    date: {
      type: Date,
      default: () => new Date()
    }
  },
  computed: {
    dayWeek: function(){
      const daysOfWeek = this.$i18n.t('date.day_names')
      return daysOfWeek[this.date.getDay()]
    },
    month: function(){
      const months = this.$i18n.t('date.month_names')
      return months[this.date.getMonth()]
    }
  },
  beforeMount(){
  }
}
</script>
